import { render, staticRenderFns } from "./TheDropShadowSvgOverlay.vue?vue&type=template&id=32dc920f&"
import script from "./TheDropShadowSvgOverlay.vue?vue&type=script&lang=js&"
export * from "./TheDropShadowSvgOverlay.vue?vue&type=script&lang=js&"
import style0 from "./TheDropShadowSvgOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports